import { IonPage } from '@ionic/react'

import {
  AccountDetailsSummaryButton,
  CompanyDetailsSummaryButton,
  DevSettings,
  PushSettings,
  ThemeSettings
} from '@apps-common/apps/portal/pages/settings/components'
import { RootHeaderButtons } from '@apps-common/components/common'
import { NavbarCompanyLogo } from '@apps-common/components/common/logos'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { Header, LayoutContainer, LayoutPadding, VertSpacerXl } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { ROUTE_SETTINGS } from '@apps-radionet-portal/config/private-routes'

export const SettingsPage = () => (
  <IonPage>
    <Header>
      <Navbar transparent startComponents={<NavbarCompanyLogo />} icons={<RootHeaderButtons />} />
      <Breadcrumbs route={ROUTE_SETTINGS} />
      <div className='flex items-center justify-between'>
        <PageTitle>Settings</PageTitle>
      </div>
    </Header>
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[10px] md:pt-[20px]'>
        <div className='flex flex-col gap-4 sm:gap-[20px] max-w-[600px] overflow-hidden'>
          <AccountDetailsSummaryButton />
          <CompanyDetailsSummaryButton />
          <ThemeSettings />
          <PushSettings />
          <Authorization roles={AUTH_CLAIMS.managementAdmin.roles} scopes={AUTH_CLAIMS.managementAdmin.scopes} ignoreDev>
            <DevSettings />
          </Authorization>
        </div>
      </LayoutPadding>
      <VertSpacerXl />
    </LayoutContainer>
  </IonPage>
)
